import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { X, Lock, KeyRound } from "lucide-react";

export const ChangePasswordModal = ({ open, onClose }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const reset = () => {
    setCurrent("");
    setNext("");
    setConfirm("");
  };

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 4) return toast.error("Yeni şifre en az 4 karakter olmalı");
    if (next !== confirm) return toast.error("Yeni şifreler eşleşmiyor");
    setLoading(true);
    try {
      await api.put("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Şifreniz güncellendi");
      reset();
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "İşlem başarısız");
    }
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 grid place-items-center px-4" onClick={onClose}>
      <div
        data-testid="change-password-modal"
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md bg-white rounded-2xl border border-[var(--fb-border)] p-6 animate-fade-up"
      >
        <div className="flex items-center justify-between mb-5">
          <h2 className="font-display font-extrabold text-xl flex items-center gap-2">
            <KeyRound className="w-5 h-5 text-[var(--fb-red)]" /> Şifre Değiştir
          </h2>
          <button data-testid="change-password-close" onClick={onClose} className="text-[var(--fb-muted)] hover:text-[var(--fb-ink)]">
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <div className="relative">
            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--fb-muted)]" />
            <input
              data-testid="current-password-input"
              type="password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              placeholder="Mevcut şifre"
              className="w-full border border-[var(--fb-border)] rounded-xl pl-9 pr-3 py-3 outline-none focus:border-[var(--fb-red)]"
            />
          </div>
          <div className="relative">
            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--fb-muted)]" />
            <input
              data-testid="new-password-input"
              type="password"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              placeholder="Yeni şifre (en az 4 karakter)"
              className="w-full border border-[var(--fb-border)] rounded-xl pl-9 pr-3 py-3 outline-none focus:border-[var(--fb-red)]"
            />
          </div>
          <div className="relative">
            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--fb-muted)]" />
            <input
              data-testid="confirm-password-input"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Yeni şifre (tekrar)"
              className="w-full border border-[var(--fb-border)] rounded-xl pl-9 pr-3 py-3 outline-none focus:border-[var(--fb-red)]"
            />
          </div>
          <button
            data-testid="change-password-submit"
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-[var(--fb-red)] hover:bg-[var(--fb-red-hover)] disabled:opacity-60 text-white font-bold py-3 rounded-full transition-colors active:scale-[0.99]"
          >
            {loading ? "Kaydediliyor..." : "Şifreyi Güncelle"}
          </button>
        </form>
      </div>
    </div>
  );
};
